<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">
  <div fxFlex="50">
    <button mat-raised-button color="basic" (click)="returnBack()" style="margin-right: 20px;">Back</button>

  </div>
  <div fxFlex="50" class="text-right">

      <span *ngIf="customer" style="margin-left: 15px; margin-right: 15px;">
        <a routerLink="/customers-overview/{{ customer.id }}">Customer Overview: {{ customer.firstName }} {{ customer.lastName }} </a>
      </span>


  </div>
</div>


<div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">

  <div fxFlex="40">

    <div *ngIf="decisionNecessary">
      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title>
            <h5>
              Decision
            </h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div style="margin: 15px;">
            <div fxLayout="row" class="list-item">
              <label fxFlex="40" class="secondary">
                Decision
              </label>
              <label fxFlex="60">
                <mat-select placeholder="Select decision" [(value)]="decision">
                  <mat-option [value]="0">Pending</mat-option>
                  <mat-option [value]="1">Approve</mat-option>
                  <mat-option [value]="2">Decline</mat-option>
                </mat-select>
              </label>
            </div>
            <div fxLayout="row" class="list-item">
              <label fxFlex="40" class="secondary">
                Comment
              </label>
              <label fxFlex="60">
                <textarea rows="6" style="width: 100%" matInput placeholder="Comment" [(ngModel)]="decisionComment"></textarea>
                <div *ngIf="decision === 2" style="background-color: rgba(255,165,0,0.49); padding: 4px 10px; border-radius: 3px;">Mandatory for declines</div>
              </label>
            </div>
            <div fxLayout="row" class="list-item">
              <label fxFlex="40" class="secondary">
                Reason for customer<br />
                <small>This will be sent to the customer</small>
              </label>
              <label fxFlex="60">
                <textarea rows="6" style="width: 100%" matInput placeholder="Comment" [(ngModel)]="decisionComment"></textarea>
                <div *ngIf="decision === 2" style="background-color: rgba(255,165,0,0.49); padding: 4px 10px; border-radius: 3px;">Mandatory for declines</div>
              </label>
            </div>

            <div fxLayout="row" class="list-item" *ngIf="decision === 1">
              <label fxFlex="40" class="secondary">
                Customer yearly income
              </label>
              <label fxFlex="60">
                <input type="number" style="width: 100%" matInput placeholder="Income" [(ngModel)]="decisionCustomerIncome" />
              </label>
            </div>
            <div fxLayout="row" class="list-item" *ngIf="decision === 1">
              <label fxFlex="40" class="secondary">
                Main income source
              </label>
              <label fxFlex="60">
                <mat-select placeholder="Main income source" [(ngModel)]="decisionCustomerIncomeType">
                  <mat-option [value]="0">None</mat-option>
                  <mat-option [value]="1">Employment</mat-option>
                  <mat-option [value]="2">Pension</mat-option>
                  <mat-option [value]="3">CapitalAssets</mat-option>
                  <mat-option [value]="4">RentalAndLeasing</mat-option>
                  <mat-option [value]="5">Agriculture and Forestry</mat-option>
                  <mat-option [value]="6">Independent Work</mat-option>
                  <mat-option [value]="7">Commercial Operation</mat-option>
                </mat-select>
              </label>
            </div>

            <div fxLayout="row" class="list-item">
              <label fxFlex="40" class="secondary">

              </label>
              <label fxFlex="60">

                <button [class.spinner]="isSavingDecision" [disabled]="isSavingDecision || !decision || (decisionComment == '' && decision === 2) || notAllFilesStatusSet" mat-flat-button [color]="decision === 1 ? 'primary' : 'accent'" (click)="saveDecision()">
                  <mat-icon>save</mat-icon>
                  <ng-container *ngIf="decision === 0">
                    Save
                  </ng-container>
                  <ng-container *ngIf="decision === 1">
                    Approve
                  </ng-container>
                  <ng-container *ngIf="decision === 2">
                    Decline
                  </ng-container>
                  and inform customer
                </button>
              </label>
            </div>
          </div>

          <ng-container *ngIf="customer">
            <button (click)="markAsVulnerable(customer)" [class.spinner]="isMarkingAsVulnerable" [disabled]="isMarkingAsVulnerable || customer.isVulnerable" class="mr-1"
                    color="grey" mat-raised-button>
              🤕 Mark customer as vulnerable
            </button>
          </ng-container>


        </mat-card-content>

      </mat-card>
    </div>

    <div>
      <mat-card class="content-card">
        <mat-card-header>
          <mat-card-title-group>
            <mat-card-title>
              <h5>Uploaded Files</h5>
            </mat-card-title>
          </mat-card-title-group>
          <div fxFlex></div>
          <div fxLayoutAlign="center center">
            <div *ngIf="notAllFilesStatusSet" style="background-color: rgba(255,165,0,0.49); padding: 4px 10px; border-radius: 3px;">All files need to be set to Success or Failed</div>
          </div>
        </mat-card-header>
        <mat-card-content>

          <ng-container *ngFor="let f of uploadedFiles">

            <div fxLayout="row">
              <div fxFlex="15">{{ datePipe.transform(f.uploadDate, "dd.MM.yyyy") }}</div>
              <div fxFlex>{{ f.originalFileName}}</div>
              <div fxFlex="20">
                <app-tri-state-checkbox *ngIf="f.mailSentDate == null" style="margin-right: 3px;" [(ngModel)]="f.isSuccess" (click)="handleFileStatusChange()">
                  <label *ngIf="f.isSuccess == true">Success</label>
                  <label *ngIf="f.isSuccess == false">Failed</label>
                  <label *ngIf="f.isSuccess == null">Pending</label>
                </app-tri-state-checkbox>

                <ng-container *ngIf="f.mailSentDate != null">
                  <label *ngIf="f.isSuccess == true">Success</label>
                  <label *ngIf="f.isSuccess == false">Failed</label>
                  <label *ngIf="f.isSuccess == null">Pending</label>
                </ng-container>

              </div>
              <div fxFlex="10" style="text-align: right;">
                <button mat-mini-fab color="primary" (click)="previewFile(f.id)" aria-label="preview">
                  <mat-icon matSuffix>play_arrow</mat-icon>
                </button>
              </div>
            </div>
          </ng-container>

        </mat-card-content>

      </mat-card>
    </div>

  </div>

  <div fxFlex="60">

    <div *ngIf="previewFileOpen">
      <mat-card *ngIf="customer" class="content-card">
        <mat-card-header>
          <mat-card-title-group>
            <mat-card-title>
              <h5 *ngIf="filename == null">Preview</h5>
              <h5 *ngIf="filename != null">{{ filename }}</h5>

              <mat-error *ngIf="errorMsg != null">{{errorMsg}}</mat-error>
            </mat-card-title>
          </mat-card-title-group>
          <div fxFlex></div>
          <div fxLayoutAlign="center center">
            <button mat-flat-button (click)="closePreview()"><mat-icon>clear</mat-icon> Close</button>
          </div>

        </mat-card-header>
        <mat-card-content style="">

          <!--
          <div class="resp-container">
            <iframe class="resp-iframe" src="https://www.youtube.com/embed/dQw4w9WgXcQ" gesture="media"  allow="encrypted-media" allowfullscreen [hidden]="isFrameHidden" frameBorder="1" [src]="urlSafe"></iframe>
          </div>
          -->

          <iframe class="resp-iframe" height="1000" width="100%" [hidden]="isFrameHidden" frameBorder="1" [src]="urlSafe" ></iframe>
          <img [src]="urlSafe" style="width: 100%; height:auto;" [hidden]="isImgHidden"/>



        </mat-card-content>
      </mat-card>
    </div>

    <div *ngIf="!previewFileOpen">


      <div>
        <mat-card *ngIf="customer" class="content-card">
          <mat-card-header>

            <mat-card-title-group>
              <mat-card-title>
                <h5>Customer</h5>
              </mat-card-title>
            </mat-card-title-group>
            <div fxFlex></div>
            <div fxLayoutAlign="center center">

            </div>

          </mat-card-header>
          <mat-card-content>


            <app-customer-badges *ngIf="customer" [customer]="customer"></app-customer-badges>

            <!-- warnings -->
            <div *ngIf="customer" style="margin-left: 10px; margin-top: 15px;">
              <div *ngIf="customer.isVulnerable" style="border-radius: 4px; background-color: orange; color: white; font-weight: bold; margin-bottom: 5px; padding: 10px;">
                🤕 This customer was marked vulnerable <ng-container *ngIf="customer.vulnerableDate">{{customer.vulnerableDate | date : 'yyyy-MM-dd'}}</ng-container>. Reason {{customer.vulnerableReason}}
              </div>
              <div *ngIf="customer.identStatus == identStatus.fail" style="border-radius: 4px; background-color: red; color: white; font-weight: bold; margin-bottom: 5px; padding: 10px;">
                <mat-icon style="color: white">beenhere</mat-icon> Ident failed!
              </div>
              <div *ngIf="customer.pepStatus == pepStatus.possibleMatch" style="border-radius: 4px; background-color: #ff9900; font-weight: bold; margin-bottom: 5px; padding: 10px;">
                <mat-icon style="color: white">perm_identity</mat-icon> Possible PEP match!
              </div>
              <div *ngIf="customer.pepStatus == pepStatus.confirmedMatch" style="border-radius: 4px; background-color: red; color: white; font-weight: bold; margin-bottom: 5px; padding: 10px;">
                <mat-icon style="color: white">perm_identity</mat-icon> Confirmed PEP match!
              </div>
            </div>



            <ng-container *ngIf="currentUserIsAdmin() && customer?.isCollectionExempt">
              <div style="background-color: #47a3ff; padding: 10px; margin-bottom: 10px; vertical-align: center;">
                <mat-icon>info</mat-icon> This customer is exempt from invoice collection
              </div>
            </ng-container>

            <div class="list-item" fxLayout="row" *ngFor="let field of fields ">
              <app-content-row [field]="field" [entity]="customer"></app-content-row>
            </div>



          </mat-card-content>

          <mat-card-actions align="end">

          </mat-card-actions>

        </mat-card>


      </div>



    </div>
  </div>


</div>
